import { RANGE, CHECKBOX, SELECT } from '../constants';
import getRangeValue from './get-range-value';
import { decodeValue } from './decode-encode';

const getFilterValueFromQuery = (key, filterProps, filterData, query) => {
  const { min, max } = filterData;
  const { rangeInterval, type } = filterProps;
  const queryValue = query[key];
  if (!queryValue && type !== RANGE) return null;

  switch (type) {
    case RANGE:
      return getRangeValue(queryValue, rangeInterval, min, max);
    case CHECKBOX:
      return typeof queryValue === 'string'
        ? [decodeValue(queryValue)]
        : queryValue.map(val => decodeValue(val));
    case SELECT:
      return decodeValue(queryValue);

    default:
      return null;
  }
};

export default getFilterValueFromQuery;
